import React from "react";
import { Card, Container } from "react-bootstrap";
import { isRouteErrorResponse, useLocation, useRouteError } from "react-router-dom";
import type { ErrorResponse } from "@remix-run/router"
import DynamicIcon from "../../components/DynamicIcon/Component";
import "./Styles.scss";
import PageLayout from "../../components/PageLayout/Component";
import { DefaultErrorCode, DefaultResponse } from "../../models/DTO/ErrorModel";
import { ErrorPageProps } from "../../@types/Rd";

const ErrorPage = ({ customMessage = undefined, errorCode = DefaultErrorCode }: ErrorPageProps): JSX.Element => {
  const erroByRoute: boolean = (customMessage == null || customMessage == ""),
    routeError: ErrorResponse | undefined = (erroByRoute && useRouteError() as ErrorResponse) || undefined,
    hasError: boolean = (routeError != null && isRouteErrorResponse(routeError)) || (customMessage != null && customMessage != ""),
    location = (erroByRoute && useLocation()) || undefined;

  let code: number = errorCode || routeError?.status || DefaultErrorCode,
    message: string | undefined = customMessage || (DefaultResponse.has(code) && DefaultResponse.get(code)) || DefaultResponse.get(DefaultErrorCode);

  if (message == DefaultResponse.get(DefaultErrorCode))
    code = DefaultErrorCode;

  if (location != null && code == 404)
    message += ` (${location.pathname})`

  return (
    <PageLayout location={`Error - ${code}`}>
      <Container id="errorDisplay" fluid className="verticalAlignment">
        <Container fluid className="horizontalAlignment">
          <Card className="verticalAlignment">
            <Card.Header className="horizontalAlignment fullWidth"><DynamicIcon Family="Feather" Name="FiAlertOctagon" /> {" "}</Card.Header>
            <Card.Body className="verticalAlignment">
              {message}
            </Card.Body>
          </Card>
        </Container>
      </Container>
    </PageLayout>
  );
}

export default ErrorPage;